import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background-50 px-4">
      <div className="text-center">
        <h1 className="text-6xl md:text-8xl font-bold text-foreground-200 mb-4">
          404
        </h1>
        <p className="text-lg text-foreground-600 mb-8">
          页面未找到，请检查链接是否正确
        </p>
        <Link
          to="/"
          className="inline-flex px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          返回首页
        </Link>
      </div>
    </div>
  );
}